import { KeyboardArrowDown as DropdownArrowIcon } from '@mui/icons-material';
import { Autocomplete, autocompleteClasses, AutocompleteProps, List, listClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Props as TextFieldBaseProps } from '../TextFieldBase';
import { CountryType } from './types';
import { Props as VMProps } from './vm';

export const countryPickerClasses = {
  ...autocompleteClasses,
};

export type Props = VMProps &
  DistributiveOmit<
    AutocompleteProps<CountryType, false, true, false>,
    'size' | 'renderInput' | 'classes' | 'options'
  > &
  Pick<
    TextFieldBaseProps,
    'label' | 'required' | 'size' | 'error' | 'helperIcon' | 'helperText' | 'fullWidth' | 'disabled'
  > & {
    classes?: Partial<Record<'root' | 'textFieldRoot' | 'popupIcon', string> & TextFieldBaseProps['classes']>;
  };

export const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  [`& .${countryPickerClasses.tag}`]: {
    backgroundColor: theme.palette.grey[200],
  },
  [`& .${countryPickerClasses.endAdornment}`]: {
    marginRight: theme.spacing(2),
  },
  [`& .${countryPickerClasses.clearIndicator}`]: {
    color: theme.palette.grey[600],
  },
})) as typeof Autocomplete;

export const PopupIcon = styled(DropdownArrowIcon)(({ theme }) => ({
  color: theme.palette.grey[600],
}));

export const Listbox = styled(List)(({ theme }) => ({
  /** used for increasing css specificity */
  [`&.${listClasses.root}`]: {
    [`.${countryPickerClasses.option}`]: {
      color: theme.palette.grey[800],
      minHeight: 48,
      [`&.${autocompleteClasses.focused}`]: {
        backgroundColor: theme.palette.grey[200],
      },
      '&[aria-selected="true"]': {
        backgroundColor: theme.palette.primary[600],
        color: theme.palette.primary.contrastColors[600],
      },
      [`&.${countryPickerClasses.focused}[aria-selected="true"]`]: {
        backgroundColor: theme.palette.primary[600],
        color: theme.palette.primary.contrastColors[600],
      },
      '&[aria-disabled="true"]': {
        backgroundColor: theme.palette.grey[50],
        color: theme.palette.grey[400],
      },
    },
  },
}));
